import I18n from 'I18n';
import { categories, marketingCategories, salesCategories, serviceCategories, tools, marketingHubTools, salesHubTools, serviceHubTools, categoriesI18nKeys, toolsI18nKeys } from 'academy-common-lib/constants/categories';
import difference from 'hs-lodash/difference';
// menu categories which contain sub-categories
const parentCategories = ['MARKETING', 'SALES', 'SERVICE'];
const parentTools = ['MARKETING_HUB_TOOLS', 'SALES_HUB_TOOLS', 'SERVICE_HUB_TOOLS'];
export const categorySubMenus = {
  MARKETING: marketingCategories,
  SALES: salesCategories,
  SERVICE: serviceCategories
};
export const toolsSubMenus = {
  MARKETING_HUB_TOOLS: marketingHubTools,
  SALES_HUB_TOOLS: salesHubTools,
  SERVICE_HUB_TOOLS: serviceHubTools
};

// Categories that are not part of the marketing, sales, or service pseudo-categories, they are not sub-categories
export const standaloneCategories = difference(categories, [...parentCategories, ...Object.values(categorySubMenus).flat()]);
export const standaloneTools = difference(tools, [...parentTools, ...Object.values(toolsSubMenus).flat()]);
const toolPrefix = 'TOOL_PREFIXED_';
// Some tools are also in categories eg. SEO, AUTOMATION. To use both in the same select, we need the values to be unique,
// so we add a prefix to the tools and remove them later
export const addToolPrefix = tool => `${toolPrefix}${tool}`;
export const removeToolPrefix = tool => tool.replace(toolPrefix, '');
export const getTopicOptions = () => {
  // First, handle category submenus (MARKETING, SALES, SERVICE)
  const categorySubmenuOptions = parentCategories.map(category => ({
    text: I18n.text(categoriesI18nKeys[category]),
    value: category,
    selectAll: true,
    options: categorySubMenus[category].map(subCategory => ({
      text: I18n.text(categoriesI18nKeys[subCategory]),
      value: subCategory
    }))
  }));

  // Add standalone categories
  const standaloneCategoryOptions = standaloneCategories.map(category => ({
    text: I18n.text(categoriesI18nKeys[category]),
    value: category
  }));

  // Handle tools submenus (MARKETING_HUB_TOOLS, SALES_HUB_TOOLS, SERVICE_HUB_TOOLS)
  const toolSubmenuOptions = parentTools.map(parentTool => ({
    text: I18n.text(toolsI18nKeys[parentTool]),
    value: parentTool,
    selectAll: true,
    options: toolsSubMenus[parentTool].map(subTool => {
      const prefixedTool = addToolPrefix(subTool);
      return {
        text: I18n.text(toolsI18nKeys[subTool]),
        value: prefixedTool
      };
    })
  }));

  // Add standalone tools
  const standaloneToolOptions = standaloneTools.map(standaloneTool => {
    const prefixedTool = addToolPrefix(standaloneTool);
    return {
      text: I18n.text(toolsI18nKeys[standaloneTool]),
      value: prefixedTool
    };
  });
  return [...categorySubmenuOptions, ...standaloneCategoryOptions, ...toolSubmenuOptions, ...standaloneToolOptions];
};

// Converts an array of categories and prefixed tools into a sorted object with the tool prefixes removed
export const getToolsAndCategoriesFromSelection = selection => {
  return selection.reduce((acc, toolOrCategory) => {
    if (toolOrCategory.startsWith(toolPrefix)) {
      acc.tools.push(removeToolPrefix(toolOrCategory));
    } else {
      acc.categories.push(toolOrCategory);
    }
    return acc;
  }, {
    tools: [],
    categories: []
  });
};

// Converts a sorted object with unprefixed tools into an array of categories and prefixed tools
export const getSelectionFromToolsAndCategories = toolsAndCategories => {
  return [...toolsAndCategories.categories, ...toolsAndCategories.tools.map(addToolPrefix)];
};